<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="maintainence_program"
                        arrows >
                    <template slot="gofixTab:maintainence_program">
                        <gofix-card fullContent class="mb-0">
                            <gofix-default-table :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                @row-click="openCreateItem"
                                @get-selected="createVendorLinkingSOR"
                                @adjustment-items="adjustmentItems"
                                ref="gofixTable">
                                <template slot="gofix_table:effective_date" slot-scope="row">
                                    {{row.item.effective_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                                </template>
                                <template slot="gofix_table:unit_price" slot-scope="row">
                                    {{ row.item.vendor_linking_sor.length > 0 ? row.item.vendor_linking_sor[0].unit_price : row.item.unit_price | formatMoney }}
                                </template>
                                <template slot="gofix_table:schedule" slot-scope="row">
                                    <template v-if="row.item.contract_term">
                                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.contract_term.contract_id}/maintenance-program/${row.item.id}?tab=maint_schedule`">
                                            <span class="text-decoration-underline">View</span>
                                        </router-link>
                                    </template>
                                    <span class="text-decoration-underline" v-else>--</span>
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" modal-class="modal-create" title="Price adjustment" hide-footer :centered="true" v-model="modals.price.open">
            <div v-bind:class="{'run-loading':modals.price.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <div class="d-flex gofix-radio-button">
                                <label class="mr-3"><input type="radio" v-model="modals.price.data.type" value="up"><span>MARK UP</span></label>
                                <label><input type="radio" v-model="modals.price.data.type" value="down"><span>MARK DOWN</span></label>
                            </div>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-number label="Percentage" v-model="modals.price.data.percentage" :integer-limit="3" suffix="%"></gofix-form-input-number>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="APPLY" @click="adjustmentItemsCallback" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'supplier-contract-maintenance-program',
        components: {},
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = true;
            delete filter.contract_term_id;
            return {
                contract_tab:tabData.supplier_contract,
                tableConfig:{
                    name: 'maintenance-program',
                    controls:{
                        create:false,
                        delete:false,
                        allItems:true,
                        sendSelected:false,
                        adjustment:true,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "sor_code",
                    sortDirection: "asc",
                },
                tableItems: [],
                loadings: {
                    group: false,
                    vendorLinking: false
                },
                modals:{
                    price:{
                        open: false,
                        loading: false,
                        data:{
                            type:"up",
                            percentage: null,
                            ids: [],
                            filter: null,
                            contract_id: this.$route.params.id
                        },
                    }
                }
            }
        },
        created () {
            if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-supplier`);
            }
            //Get contract data
            if((!this.contract || !this.contract.id) || this.contract.hasOwnProperty('id')) {
                this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                    .catch(error => { this.$router.push(`/v2/contract-supplier`) })
            }
        },

        computed: {
            ...mapGetters({
                contract: 'ContractController/SContract',
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            },
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                let params = Object.assign(tableRequest,{
                    supplier_contract_id: this.$route.params.id,
                });
                if(this.groupSelected && params.filter && params.filter.id){
                    params.filter.id.value = parseInt(this.groupSelected);
                }

                await this.$store.dispatch("v2SorController/getItems", params)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the SOR", "danger");
                        reject();
                    })
            },
            openCreateItem(item){
                this.$store.commit("v2SorController/setItem",null);
                this.$router.push({name:"s-edit-maintenance",params:{maintenance_id:item.id}});
            },
            sendSelected(){
                this.$refs.gofixTable.sendSelectedData();
            },
            adjustmentItems(ids, filter) {
                this.modals.price.open = true;
                this.modals.price.data.ids = ids;
                this.modals.price.data.filter = filter;
            },
            adjustmentItemsCallback(){
                let params = JSON.parse(JSON.stringify(this.modals.price.data));
                params.percentage = this.$accounting.unformat(params.percentage);
                if(!params.percentage){
                    return this.$alertNotification("Please enter the percentage", "danger");
                }
                if(params.type == 'down' && params.percentage > 100){
                    return this.$alertNotification("Mark Down: can't input SOR Adjustment > 100%", "danger");
                }
                this.modals.price.loading = true;
                this.$store.dispatch("v2SorController/adjustmentItems",params)
                    .then( response => {
                        this.modals.price.loading = false;
                        this.modals.price.open = false;
                        this.$alertNotification(this.$notificationV2('editing', 'adjustment'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(err => {
                        this.modals.price.loading = false;
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    });
            },

            /*--  -------------------------*/
            //Get group
            createVendorLinkingSOR(ids, filter) {
                let params = {
                    contract_id: this.$route.params.id,
                    tickID: ids,
                    untickID: [],
                    filter: filter,
                    isCMS: true
                };
                if(!filter){
                    //Filter untick
                    this.tableItems.map(item => {
                        if(!ids.includes(item.id)) {
                            params.untickID.push(item.id);
                        }
                    })
                }
                if(this.loadings.vendorLinking) return;
                this.loadings.vendorLinking = true;
                this.$store.dispatch("v2SorController/createVendorLinkingSOR",params)
                    .then( response => {
                        this.$alertNotification(this.$notificationV2('adding', 'vendor_linking_sor'));
                        this.loadings.vendorLinking = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    }).catch(err => {
                    this.loadings.vendorLinking = false;
                    if(err.response.data.error.message.error) {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    } else {
                        this.$alertNotification("Error", "danger");
                    }
                });
            },
            /*-----------------------------*/
        }
    }
</script>
